export default {
  duration: {
    lessThanMinute: 'Moins d\'une minute',
    unknown: 'Durée inconnue',
  },
  relative: {
    justNow: 'À l\'instant',
    ago: 'il y a {duration}',
    in: 'dans {duration}',
  },
  formats: {
    long: 'PP', // e.g., 29 avr. 2021
    short: 'P', // e.g., 29/04/2021
    longWithTime: 'PP, p', // e.g., 29 avr. 2021, 09:30
    shortWithTime: 'P, p', // e.g., 29/04/2021, 09:30
    longWithDay: 'EEEE, PP', // e.g., lundi, 29 avr. 2021
    longWithTimeAndDay: 'EEEE, PP, p', // e.g., lundi, 29 avr. 2021, 09:30
  },
};
